import script from "./CustomerFamilySearch.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerFamilySearch.vue?vue&type=script&setup=true&lang=js"

import "./CustomerFamilySearch.vue?vue&type=style&index=0&id=59d4c431&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d4c431"]])

export default __exports__